import { useStore } from '@nanostores/react'
import * as Scheduled from 'features/scheduled-messages'
import { useSwitcher } from 'shared/hooks'

import { useCurrentId } from '../../hooks'
import { EmojiActionsPopover } from '../Emoji/Select'
import * as Files from '../Files'
import { $editMessage } from '../MessageForm/form'
import { MessageForm } from '../MessageForm/MessageForm'
import css from './Chat.module.css'
import { Conversation } from './Conversation'

export function Chat() {
	const conversation = useCurrentId()

	const isScheduled = useStore(Scheduled.$isScheduledShown)
	const editMessage = useStore($editMessage)

	const expand = useSwitcher(false)

	return conversation ? (
		<>
			{isScheduled ? (
				<Scheduled.UI.Messages
					className={expand.isOn ? css.shrinkChat : css.expandChat}
				/>
			) : (
				<Conversation
					className={expand.isOn ? css.shrinkChat : undefined}
					key={conversation}
				/>
			)}

			<MessageForm isExpand={expand.isOn} toggleExpand={expand.toggle} />

			<EmojiActionsPopover />

			{!isScheduled && !editMessage && <Files.Drop />}

			<Scheduled.UI.TimePicker />
		</>
	) : null
}
